/*
 * Probably a fork of https://github.com/brightcove/videojs-thumbnails/
 * Modified quite a bit by Calvin
 */

export default function registerThumbnailPlugin(videojs) {
  var defaults = {
      width: 0,
      height: 0,
      basePath: '',
    },
    extend = function () {
      var args, target, i, object, property
      args = Array.prototype.slice.call(arguments)
      target = args.shift() || {}
      for (i in args) {
        object = args[i]
        for (property in object) {
          if (object.hasOwnProperty(property)) {
            if (typeof object[property] === 'object') {
              target[property] = extend(target[property], object[property])
            } else {
              target[property] = object[property]
            }
          }
        }
      }
      return target
    },
    getComputedStyle = function (el, pseudo) {
      return function (prop) {
        if (window.getComputedStyle) {
          return window.getComputedStyle(el, pseudo)[prop]
        } else {
          return el.currentStyle[prop]
        }
      }
    },
    offsetParent = function (el) {
      if (
        el.nodeName !== 'HTML' &&
        getComputedStyle(el)('position') === 'static'
      ) {
        return offsetParent(el.offsetParent)
      }
      return el
    },
    getScrollOffset = function () {
      if (window.pageXOffset) {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset,
        }
      }
      return {
        x: document.documentElement.scrollLeft,
        y: document.documentElement.scrollTop,
      }
    },
    parseImageLink = function (basePath, imglocation) {
      var lsrc, clip, hashindex, hashstring
      hashindex = imglocation.indexOf('#')
      if (hashindex === -1) {
        return { src: imglocation, w: 0, h: 0, x: 0, y: 0 }
      }
      lsrc = imglocation.substring(0, hashindex)
      hashstring = imglocation.substring(hashindex + 1)
      if (hashstring.substring(0, 5) !== 'xywh=') {
        return { src: basePath + lsrc, w: 0, h: 0, x: 0, y: 0 }
      }
      var data = hashstring.substring(5).split(',')
      return {
        src: basePath + lsrc,
        w: parseInt(data[2]),
        h: parseInt(data[3]),
        x: parseInt(data[0]),
        y: parseInt(data[1]),
      }
    }

  /**
   * register the thubmnails plugin
   */
  videojs.registerPlugin('thumbnails', function (options) {
    var div,
      box,
      settings,
      img,
      arrow,
      player,
      progressControl,
      duration,
      moveListener,
      moveCancel,
      thumbTrack,
      tracks
    // don't do this. defaults is shared between instances
    //defaults.basePath = options.basePath || defaults.basePath;
    settings = extend({}, defaults, options)
    player = this
    window._player = player

    player.ready(function () {
      tracks = player.remoteTextTracks()
      checkForTracks()
      if (!thumbTrack) tracks.addEventListener('addtrack', checkForTracks)
    })

    function checkForTracks() {
      if (thumbTrack) return
      for (var i = 0; i < tracks.length; i++) {
        if (
          tracks[i].kind === 'metadata' &&
          tracks[i].src &&
          tracks[i].src.substr(0, 4) === 'http'
        ) {
          thumbTrack = tracks[i]
          // Chrome needs this
          thumbTrack.mode = 'hidden'
          break
        }
      }
      if (!thumbTrack) return

      // CALVIN: vtt URLs are supposed to be relative to the VTT file
      // CALVIN: unfortunately, src is undefined in Safari :(
      defaults.basePath =
        defaults.basePath ||
        thumbTrack.src.substring(0, thumbTrack.src.lastIndexOf('/') + 1)
      ;(function () {
        var progressControl, addFakeActive, removeFakeActive
        // Android doesn't support :active and :hover on non-anchor and non-button elements
        // so, we need to fake the :active selector for thumbnails to show up.
        if (navigator.userAgent.toLowerCase().indexOf('android') !== -1) {
          progressControl = player.controlBar.progressControl

          addFakeActive = function () {
            progressControl.addClass('fake-active')
          }
          removeFakeActive = function () {
            progressControl.removeClass('fake-active')
          }

          progressControl.on('touchstart', addFakeActive)
          progressControl.on('touchend', removeFakeActive)
          progressControl.on('touchcancel', removeFakeActive)
        }
      })()

      // create the thumbnail
      div = document.createElement('div')
      div.className = 'vjs-thumbnail-holder'

      // CALVIN addition
      box = document.createElement('div')
      box.className = 'vjs-thumbnail-box'
      div.appendChild(box)

      img = document.createElement('img')
      box.appendChild(img)
      img.className = 'vjs-thumbnail'

      // CALVIN addition
      arrow = document.createElement('div')
      arrow.className = 'vjs-arrow-down'
      div.appendChild(arrow)

      // keep track of the duration to calculate correct thumbnail to display
      duration = player.duration()

      // when the container is MP4
      player.on('durationchange', function (event) {
        duration = player.duration()
      })

      // when the container is HLS
      player.on('loadedmetadata', function (event) {
        duration = player.duration()
      })

      // add the thumbnail to the player
      progressControl = player.controlBar.progressControl
      progressControl.el().appendChild(div)

      moveListener = function (event) {
        var mouseTime,
          time,
          active,
          left,
          setting,
          pageX,
          right,
          width,
          halfWidth,
          pageXOffset,
          clientRect,
          playerRect,
          min,
          max

        active = 0
        pageXOffset = getScrollOffset().x
        clientRect = offsetParent(progressControl.el()).getBoundingClientRect()
        right = (clientRect.width || clientRect.right) + pageXOffset

        pageX = event.pageX
        if (event.changedTouches) {
          pageX = event.changedTouches[0].pageX
        }

        // find the page offset of the mouse
        left =
          pageX ||
          event.clientX +
            document.body.scrollLeft +
            document.documentElement.scrollLeft
        // subtract the page offset of the positioned offset parent
        left -=
          offsetParent(progressControl.el()).getBoundingClientRect().left +
          pageXOffset

        // CALVIN: Calculate min/max based on player vs progressbar sizes
        playerRect = offsetParent(player.el()).getBoundingClientRect()
        min = playerRect.x - clientRect.x
        max = playerRect.width - min

        // CALVIN: No need for fuzzy math here ... the TimeTooltip already displays the time.
        // Using that exact time guarantees a consistent user experience.
        // apply updated styles to the thumbnail if necessary
        // mouseTime is the position of the mouse along the progress control bar
        // `left` applies to the mouse position relative to the player so we need
        // to remove the progress control's left offset to know the mouse position
        // relative to the progress control
        var time_v = progressControl
          .el()
          .getElementsByClassName('vjs-time-tooltip')[0]
          .innerHTML.split(/:/)
        var seconds = parseInt(time_v.pop())
        var minutes = parseInt(time_v.pop())
        var hours = time_v.length > 0 ? parseInt(time_v.pop()) : 0

        //mouseTime = Math.floor((left - progressControl.el().offsetLeft) / progressControl.width() * duration);
        mouseTime = seconds + 60 * minutes + 60 * 60 * hours

        //Now check which of the cues applies
        var cnum = thumbTrack && thumbTrack.cues && thumbTrack.cues.length
        i = 0
        while (i < cnum) {
          var ccue = thumbTrack.cues[i]
          if (ccue.startTime <= mouseTime && ccue.endTime >= mouseTime) {
            setting = parseImageLink(settings.basePath, ccue.text)
            break
          }
          i++
        }
        //None found, so show nothing
        if (typeof setting === 'undefined') {
          moveCancel()
          return
        }

        //Changed image?
        if (setting.src && img.src != setting.src) {
          var baseUrl = ''
          // Make the
          if (setting.src[0] === '/') {
            var baseUrl = player.currentSrc()
            baseUrl = baseUrl.substring(0, baseUrl.lastIndexOf('/'))
          }
          img.src = baseUrl + setting.src
        }

        //Fall back to plugin defaults in case no height/width is specified
        if (setting.w === 0) {
          setting.w = settings.width
        }
        if (setting.h === 0) {
          setting.h = settings.height
        }

        //Set the container width/height if it changed
        if (box.style.width != setting.w || box.style.height != setting.h) {
          box.style.width = setting.w + 'px'
          box.style.height = setting.h + 'px'
        }

        //Set the image cropping
        img.style.left = -setting.x + 'px'
        img.style.top = -setting.y + 'px'
        img.style.clip =
          'rect(' +
          setting.y +
          'px,' +
          (setting.w + setting.x) +
          'px,' +
          (setting.y + setting.h) +
          'px,' +
          setting.x +
          'px)'

        // Position arrow top
        arrow.style.top = setting.h + 3 + 'px'

        width = setting.w + 4
        halfWidth = width / 2

        // make sure that the thumbnail doesn't fall off the right side of the left side of the player
        if (left + halfWidth > max) {
          arrow.style.left = width - right + left - 13 + 'px'
          left = right - width
        } else if (left - halfWidth < min) {
          arrow.style.left = left - 13 + 'px'
          left = 0
        } else {
          arrow.style.left = halfWidth - 13 + 'px'
          left = left - halfWidth
        }

        div.style.left = left + 'px'
        player.addClass('with-thumbnail')
      }

      // update the thumbnail while hovering
      progressControl.on('mousemove', moveListener)
      progressControl.on('touchmove', moveListener)

      moveCancel = function (event) {
        div.style.left = '-10000px'
        player.removeClass('with-thumbnail')
      }

      // move the placeholder out of the way when not hovering
      progressControl.on('mouseout', moveCancel)
      progressControl.on('touchcancel', moveCancel)
      progressControl.on('touchend', moveCancel)
      player.on('userinactive', moveCancel)
    }
  })
}
